import { TeacherManagementPage } from './TeacherManagementPage';
export default TeacherManagementPage;
